import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
} from '@angular/core';
import { BaseComponent } from 'src/app/moov-common/base/base.component';
import { ImpactLevelUpperThresholds } from '../culture-impact-tag/culture-impact-tag.component';

@Component({
  selector: 'app-culture-card',
  templateUrl: './culture-card.component.html',
  styleUrl: './culture-card.component.scss',
})
export class CultureCardComponent extends BaseComponent {
  @Input() cultureScore: number = 0; // 0-100
  @Input() familyName = '';
  @Input() impact = 0; // 0-100
  @Input() cultuerIcon = '';
  @Input() isSelected: boolean = false;
  @Input() isLoading: boolean = true;
  @Output() onCultureSelected = new EventEmitter();
  isHighImpact: boolean = false;
  progressBarColorString: string = ''; // set based on cultureScore

  constructor() {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.calculateProgressBarColor();
    this.updateIsHighImpact();
    // console.log(`impact is = ${this.impact}`);
    
  }

  ngOnChanges(changes: SimpleChanges) {
    this.ifChanged(changes.cultureScore, () =>
      this.calculateProgressBarColor()
    );
    this.ifChanged(changes.impact, () => this.updateIsHighImpact());
  }

  calculateProgressBarColor(): void {
    this.progressBarColorString = this.utilsService.
    calculateProgressBarColor(this.cultureScore);
  }

  updateIsHighImpact(): void {
    this.isHighImpact = this.impact > ImpactLevelUpperThresholds.Medium;
    // console.log( `isHighImpact = ${this.isHighImpact}`);
  }

  onCultureCardClick(): void {
    this.onCultureSelected.emit();
  }
}
